module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widget/sort-widgets/sort-page-widgets/sort-page-widgets.component.css
// module id = ./src/app/widget/sort-widgets/sort-page-widgets/sort-page-widgets.component.css
// module chunks = main